import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import InputField from "../../../UIElements/InputField";
import CustomButton from "../../../UIElements/CustomButton";
import { SignUpContext } from "../../../../contexts";
import "../../../components-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { isValidSiret } from "../../../../helpers";
import { getEstablishmentBySiret } from "../../../../services";
// import { membershipNumberRegex } from "../../../../consts";

type EstablishmentGeneralInfosFormProps = {
    goto: (step: number) => void;
    nextStep: number;
};

const validationSchema = yup.object({
    // synerpaNum: yup
    //     .string()
    //     .matches(
    //         membershipNumberRegex,
    //         "Veuillez renseigner un numéro synerpa valide"
    //     )
    //     .required("Veuillez renseigner le numéro synerpa"),
    siret: yup
        .string()
        .required("Veuillez renseigner le numéro de SIRET")
        .test("validSiret", "Le numéro de siret n'est pas valide", (siret) =>
            isValidSiret(siret)
        )
        .test(
            "siretAlreadyExist",
            "Un établissement existe déjà avec ce numéro de SIRET.",
            async (siret) => {
                if (siret && isValidSiret(siret)) {
                    const establishmentBySiretRes =
                        await getEstablishmentBySiret(siret);
                    return establishmentBySiretRes.id ? false : true;
                }
                return true;
            }
        ),
    companyName: yup.string().required("Veuillez renseigner la raison sociale"),
});

export default function EstablishmentGeneralInfosForm({
    goto,
    nextStep,
}: EstablishmentGeneralInfosFormProps) {
    const { updateSignupForm, ...signupForm } = useContext(SignUpContext);

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({
        defaultValues: {
            // synerpaNum: signupForm?.signupUser.establishment?.synerpaNum ?? "",
            siret: signupForm?.signupUser?.establishment?.siret ?? "",
            companyName:
                signupForm?.signupUser?.establishment?.companyName ?? "",
        },
        resolver: yupResolver(validationSchema),
    });

    const onSubmit = async (data: any) => {
        updateSignupForm({
            ...signupForm,
            step: nextStep,
            signupUser: {
                ...signupForm.signupUser,
                establishment: {
                    ...signupForm.signupUser.establishment,
                    ...data,
                },
            },
        });

        goto(nextStep);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2.5rem",
            }}
        >
            <Box
                display="flex"
                sx={{
                    flexDirection: "column",
                    gap: "0.5rem",
                }}
            >
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "1.25rem",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                    }}
                >
                    À propos de votre établissement
                </Typography>
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "0.875rem",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "1.125rem",
                    }}
                >
                    Renseignez les informations relatives à votre établissement
                </Typography>
            </Box>

            <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
                {/* <Controller
                    name="synerpaNum"
                    control={control}
                    render={({ field: { ref, ...others } }) => {
                        return (
                            <InputField
                                label={"Numéro d’adhérent SYNERPA *"}
                                fullWidth
                                {...others}
                                placeholder="F3221"
                                inputProps={{
                                    maxLength: 5,
                                }}
                                errortext={
                                    errors.synerpaNum
                                        ? errors.synerpaNum.message
                                        : ""
                                }
                            />
                        );
                    }}
                /> */}
                <Controller
                    name="siret"
                    control={control}
                    render={({ field: { ref, ...others } }) => {
                        return (
                            <InputField
                                errortext={
                                    errors.siret ? errors.siret.message : ""
                                }
                                {...others}
                                type="numeric"
                                placeholder="50954318700025"
                                inputProps={
                                    {
                                        // maxLength: 14,
                                        // type: "numeric",
                                    }
                                }
                                label={"Numéro de SIRET *"}
                                fullWidth
                            />
                        );
                    }}
                />
                <Controller
                    name="companyName"
                    control={control}
                    render={({ field: { ref, ...others } }) => {
                        return (
                            <InputField
                                {...others}
                                label={"Nom de l'établissement *"}
                                fullWidth
                                errortext={
                                    errors.companyName
                                        ? errors.companyName.message
                                        : ""
                                }
                            />
                        );
                    }}
                />

                <CustomButton
                    type="submit"
                    label="Étape suivante"
                    customsx={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "3.5rem",
                        marginBottom: "auto",
                    }}
                />
            </form>
        </Box>
    );
}
